import { useTranslation } from 'react-i18next';
import { Button, cn } from '@ideoz/ui';
import { SUPPORTED_LANGUAGES } from '../i18n';

/**
 * Language switcher for the profile page. Toggles the app between English and
 * Arabic; changing the language persists it (localStorage) and flips the whole
 * document to RTL/LTR (handled in `src/i18n`).
 */
export function LanguageSwitcher(): JSX.Element {
  const { t, i18n } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || 'en').split('-')[0];

  return (
    <div className="space-y-2" data-testid="language-switcher">
      <div>
        <p className="text-sm font-medium text-gray-900 dark:text-gray-100">{t('language.label')}</p>
        <p className="text-xs text-gray-500 dark:text-gray-400">{t('language.description')}</p>
      </div>
      <div className="flex gap-2">
        {SUPPORTED_LANGUAGES.map((lng) => {
          const active = current === lng;
          return (
            <Button
              key={lng}
              type="button"
              variant={active ? 'primary' : 'secondary-gray'}
              size="sm"
              onClick={() => i18n.changeLanguage(lng)}
              aria-pressed={active}
              className={cn('min-w-24', active && 'pointer-events-none')}
              data-testid={`language-option-${lng}`}
            >
              {lng === 'ar' ? t('language.arabic') : t('language.english')}
            </Button>
          );
        })}
      </div>
    </div>
  );
}

export default LanguageSwitcher;
